<script>
  export default {
    props: {
      brandList: {
        type: Array,
        default: () => {
          return [
            {
              "title": "BlcakBerry",
              "alias": "blcakberry",
              "logo": "https://assets.codepen.io/1759070/logo_1.svg",
            },
          ]
        }
      }
    }
  }
</script>

<template>
  <div :class="$style.listBrand">
    <div class="row">
      <router-link
        v-for="(brandItem, index) in brandList"
        :key="`brandList-${index}`"
        :to="{ name: 'brand-item', params: { brandAlias: brandItem.alias } }"
        class="listBrand__item col-lg-12 col-4"
      >
        <template v-if="brandItem.logo || brandItem.logo_image">
          <img
            :src="brandItem.logo || brandItem.logo_image"
            :alt="`${brandItem.title}`"
            class="listBrand__img"
          />
        </template>
        <template v-else>
          {{ brandItem.title }}
        </template>
        <i class="fal fa-chevron-right"></i>
      </router-link>
      <slot/>
    </div>
  </div>
</template>
<style lang="scss" module>
  .listBrand {
    :global {
      .listBrand {
        &__item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          color: $color-gray-7;

          &:not(:last-child) {
            // margin-bottom: 20px;
          }

          &:hover {
            color: $color-primary;
            text-decoration: none;
          }
          @include max-lg {
            justify-content: space-around;
            i {
              display: none;
            }
            &:not(:last-child) &:not(:nth-last-child(2)) {
              margin-bottom: 1.5rem;
              border-right: 1px solid $color-gray-2;
            }
          }
        }

        &__img {
          max-width: 190px;
          margin-right: 1rem;
          @include max-lg {
            max-width: initial;
            max-height: 55px;
          }
          @include max-md {
            max-height: 40px;
          }
        }

        &__item {

        }
      }
    }
  }
</style>
